import { Inventory } from './inventory.js';
import autosize from 'autosize';
import * as d3 from "d3";

require('./bootstrap');
require('jquery.fancytree/dist/modules/jquery.fancytree.wide');
require('jquery.fancytree/dist/modules/jquery.fancytree.filter');
window.uploadcloud = require('./uploadcloud');
window.oci = require('./oci').default;
window.Inventory = Inventory;
window.d3 = d3;
const selectize = require('selectize');
const flatpickr = require('flatpickr');
const fancytree = require('jquery.fancytree');

$(function () {
    /**
     * XCRF Token for Aja calls
     */
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        cache: false
    });

    /**
     * Plugin to select/clear all in selectize
     */
    selectize.define('select_clear_all', function(options) {
        if (this.settings.mode === 'single') return
        let self = this
        self.setup = (function() {
            let original = self.setup
            return function() {
                original.apply(this, arguments)
                // Listening to different buttons based on options
                // Otherwise all selectize in page will be impacted
                $(`#${options.buttons}_select_all`).on('click', function() {
                    self.setValue($.map(self.options, function(v, k) {
                        return k
                    }))
                    // We need to trigger change for select_all
                    self.trigger('change')
                })
                $(`#${options.buttons}_clear_all`).on('click', function() {
                    self.setValue([])
                    // No need to trigger change as it seems to be triggered already
                })
            }
        })()
    })

    /**
     * Selectize default
     */
    $('[data-selectize-options="default"]').selectize({
        delimiter: ';',
        labelField: "label",
        valueField: "value",
        searchField: "label",
        allowEmptyOption: true,
        onInitialize: function() {
            // We hide the input on init to avoid issue on small screens
            this.hideInput()
        }
    })

    /**
     * Selectize for connections
     */
    $('[data-selectize-options="connection"]').selectize({
        delimiter: ';',
        labelField: "label",
        valueField: "value",
        searchField: ['label', 'url'],
        allowEmptyOption: true,
        render: {
            item: function(data, escape) {
                return `
                <div data-value="${escape(data.value)}" data-version="${escape(data.version || null)}" data-kbversion="${escape(data.kbversion || null)}">
                    ${escape(data.label)}
                </div>`;
            },
            option: function(data, escape) {
                return `
                <div class="option" data-value="${escape(data.value)}" data-version="${escape(data.version || null)}" data-kbversion="${escape(data.kbversion || null)}">
                    <div>${escape(data.label)}</div>
                    <div class="small text-muted">${escape(data.url)}</div>
                </div>`;
            }
        },
        onInitialize: function() {
            // We hide the input on init to avoid issue on small screens
            this.hideInput();
            let options = [];
            this.$input.find('option').each(()=> options.push({ url: $(this).data('url') }));
            this.addOption(options);
        }
    })

    /**
     * Selectize with avatar (ex: acl)
     */
    $('[data-selectize-options="users"]').selectize({
        render: {
            item: function (data, escape) {
                return `
                <div class="d-flex align-items-center selectize-avatar">
                    ${escape(data.text)} (${escape(data.email)})
                </div>`
            },
            option: function (data, escape) {
                return `
                <div class="option">
                    <div class="d-flex lh-sm py-1 align-items-center">
                        <span class="avatar mr-2">${escape(data.text).split(' ').map((v) => v[0]).join('')}</span>
                        <div class="flex-fill">
                            <div class="strong">${escape(data.text)}</div>
                            <div class="text-muted small">
                                <a href="#" class="text-reset">${escape(data.email)}</a>
                            </div>
                        </div>
                    </div>
                </div>`
            }
        },        
        plugins : {
            'remove_button': {},
            'select_clear_all': {
                'buttons': 'share'
            }
        }
    })

    /**
     * Selectize with image (ex: logo)
     */
     $('[data-selectize-options="image"]').selectize({
        render: {
            option: function (data, escape) {
                return `<div class="option">${data.image} ${escape(data.text)}</div>`
            },
            item: function (data, escape) {
                return `<div class="d-flex align-items-center">${data.image} ${escape(data.text)}</div>`
            }
        }
    })

    /**
     * Selectize with tags remove (ex: companies)
     */
    $('[data-selectize-options="tags"]').selectize({
        plugins: ['remove_button']
    })

    /**
     * Selectize create tags (ex: version)
     */
    $('[data-selectize-options="add-tags"]').selectize({
        delimiter: ',',
        persist: false,
        plugins: ['remove_button'],
        create: function(input) {
            return {
                value: input,
                text: input
            }
        }
    })

    /**
     * Selectize create tags with select all buttons (ex: stats)
     */
     $('[data-selectize-options="add-tags-with-buttons"]').each(function() {  
        let element = $(this)
        let label = $(`[for=${element.attr('name')}]`)
        let selectAll = label.find("[id$=select_all]")
        let clearAll = label.find("[id$=clear_all]")

        $(this).selectize({
            delimiter: ',',
            persist: false,
            plugins: {
                'remove_button': {},
                'select_clear_all': {
                    'buttons': (selectAll.length || clearAll.length) ? element.attr('name') : null
                }
            },
            create: function(input) {
                return {
                    value: input,
                    text: input
                }
            }
        })
    })

    /**
     * Selectize with remove button
     */
    $('[data-selectize-options="remove-button"]').each(function() {
        let maxItems = $(this).data("maxItems") || 10
        $(this).selectize({
            delimiter: ';',
            labelField: "label",
            valueField: "value",
            searchField: "label",
            maxItems: maxItems,
            plugins: ['remove_button'],
            create: function(input) {
                return {
                    value: input,
                    text: input
                }
            }
        })
    })

    /**
     * Autoload options for a selective object (from data-list-auto)
     * 
     * @param {object} selectize The selectize object
     * @param {object} options The options
     * @return {void}
     */
    const dataListAutoLoad = (selectize, options) => {
        let select = $(`[id$="${selectize.$input['0'].id}"]`);
        // We must split because for initialize data from blade - can't use array in blade    
        options.selected = selectize.getValue() || Array.isArray(options.selected) ? options.selected : (options.selected ? options.selected.split(',') : null);
        selectize.clear();
        selectize.clearOptions();
        
        $.ajax({
            url: options.url,
            type: 'GET',
            data: {
                'template': options.template
            }
        })
        .then(function (data) {
            // Add option in selectize
            for (var i = 0; i < data.length; i++) {
                selectize.addOption({
                    value: data[i].id,
                    text: data[i].text || data[i].name,
                    identifier: data[i].identifier || null,
                    defaultTemplate: data[i].user_id === 0
                });
            }
            // Define the default
            if (options.selected) {
                // May have issue if multiple?
                selectize.setValue(options.selected);
                // Save the selected on the original element options (that is not selectize)
                select.data('listAuto', options)
            }
        });
    }

    /**
     * Selectize for business units, implementation projects, etc.
     */
    let dataListAutoListenTo = []
    let dataListAutoListenNames = []
    $('[data-list-auto]').each(function(index) {
        let select = $(this)
        let options = select.data('listAuto')
        let multiple = options.multiple || false
        // Carefull if maxItems is null then not limit == same as multiple
        let maxItems = options.max_items || (options.multiple ? null : 1)
        let plugins
        let render
        let autoTrigger = $('[data-list-auto]').length === index + 1
        
        // Make multiple
        select.prop('multiple', multiple)

        // Init, we use predefined options due to conflict with HTML/Json such as ", ', etc.
        if (multiple && ['bu', 'le', 'led'].includes(options.options)) {
            plugins = {
                'remove_button': {},
                'select_clear_all': {
                    'buttons': options.options
                }
            }
        }

        // We have special renders
        if (options.options === 'le') {
            render = {
                option: function(item, escape) {
                    return `
                    <div class="row option" data-selectable="">
                        <div class="col" data-value="${escape(item.value)}">${escape(item.text)}</div>
                        <div class="col"><strong>${escape(item.identifier)}</strong></div>
                    </div>`;
                }
            }
        }
        if (options.template) {
            render = {
                option: function(item, escape) {
                    return `<div class="option" data-value="${escape(item.value)}" data-default-template="${escape(item.defaultTemplate)}">${escape(item.text)}</div>`;
                }
            }
        }

        // Init the selectize        
        select.selectize({
            searchField: ['text', 'value', 'identifier'],
            plugins: plugins,
            render: render,
            maxItems: maxItems,
            onChange: function () {
                if (options.max_items && options.alert_max_items) {
                    $(options.alert_max_items).toggleClass('d-none', this.items.length < options.max_items)
                }
            }
        })

        // Fetch the instance
        let selectize = select[0].selectize;

        // Create listener if set in the options and if it was not set previously
        if (options.listen && options.url && (!dataListAutoListenTo.includes(options.listen) || !dataListAutoListenNames.includes(select.attr('name'))))
        {
            // Add in lists to avoid duplicate listerners
            dataListAutoListenTo.push(options.listen)
            dataListAutoListenNames.push(select.attr('name'))
            $(options.listen).on('change', function(e) {
                let id = $(this).val()
                if (id) {
                    if (['bu', 'le', 'led', 'projects'].includes(options.options)) {
                        options.url = options.url.replace(/\/[0-9]+\//gm, `/${id}/`)
                    }
                    dataListAutoLoad(selectize, options)
                }
            })
        } else if (!options.listen) {
            dataListAutoLoad(selectize, options)
        }

        // Add custom event to make reload easier
        $(this).on('reloadSelectize', () => dataListAutoLoad(selectize, options))

        // If it is the last item we auto trigger all the listerners to force the load of data
        if (autoTrigger) {
            let uniqueListerners = [...new Set(dataListAutoListenTo)]
            uniqueListerners.forEach(element => $(element).trigger('change'))
        }
    })

    /**
    * Return the string by replacing the ID from element value
    * 
    * @param {element} element The Jquery element
    * @param {string} string The string
    * @return {string} 
    */
    const replaceIdFrom = (element, string) => {
        return string.replace(/\/[0-9]+\//gm, `/${element.val()}/`)
    }

    /**
     * Selectize for users filters
     */
    $('[data-users-filter-url]').each(function(index, element) {
        let url = $(this).data('usersFilterUrl');
        let connection = $($(this).data('connection'));
        let selected = $(this).data('selected') || [];        

        if (replaceIdFrom(connection, url)) {
            $(this).selectize({
                valueField: 'id',
                labelField: 'username',
                searchField: ['id', 'username'],
                // We fact the username from the ID because we don't want to have ajax query for each items
                // and we have the username in the selected options
                options: selected.map(id => ({ 'id': id, 'username': id })),
                items: selected,
                create: false,
                plugins: ['remove_button'],
                load: function (query, callback) {
                    if (!query.length) return callback();
                    $.ajax({
                        url: replaceIdFrom(connection, url),
                        type: 'GET',
                        data: {
                            q: query
                        },
                        success: function (res) {
                            callback(res);
                        },
                        error: function () {
                            callback();
                        }
                    })
                }
            });
            connection.on('change', () => {
                window[`users-filter-${index}`][0].selectize.clear();
                window[`users-filter-${index}`][0].selectize.clearOptions();
            });
        }
    });

    /**
     * Selectize for reports filters
     */
    $('[data-reports-filter-url]').each(function(index, element) {
        let url = $(this).data('reportsFilterUrl');
        let maxItems = $(this).data('maxItems') || null;

        $(this).selectize({
            valueField: 'id',
            labelField: 'name',
            searchField: ['id', 'name', 'shortVersion'],
            create: false,
            plugins: ['remove_button'],
            maxItems: maxItems,
            persist:false,
            preload: false,
            render: {
                item: function(item, escape) {
                    return `<div>${escape(item.id)} - ${escape(item.name)} (${escape(item.shortVersion)})</div>`;
                },
                option: function(item, escape) {
                    return `
                    <div class="option">
                        ${escape(item.id)} - ${escape(item.name)} (${escape(item.shortVersion)}) <small>${escape(item.completed_at.slice(0,16).replace('T', ' '))}</small>
                    </div>`;
                }
            },            
            load: function (query, callback) {
                this.clearOptions();
                $.ajax({
                    url: url,
                    type: 'GET',
                    data: {
                        q: query
                    },
                    success: function (res) {
                        callback(res);
                    },
                    error: function () {
                        callback();
                    }
                })
            }
        });
    });

    /**
     * Clear another field (ex: search)
     */
    $('[data-clear-input]').on('click', function(e) {
        e.preventDefault();
        let id = $(this).data("clearInput")
        $(`#${id}`).val("").trigger('keyup')
    });

    /**
     * Flatpickr with default
     */
    $('[data-flatpickr]').each(function() {
        let options = $(this).data('flatpickr');
        $(this).flatpickr(options);
    });

    /**
     * Autoresize textarea
     */
    autosize($('[data-toggle="autosize"]'))

    /**
     * Event listener on a field to enable/disable other
     */
    $("[data-toggle-fields]").each(function() {
        let fields = $(this).data("toggleFields")
        $(this).on("change", function(e) {
            $(`${fields}`).prop("disabled", !$(this).is(':checked'))
        })
    })

    /**
     * For all data-field-show/hide-if, data-field-enable/disable-if
     * We must only trigger the click 1 time on the fields listened
     * Therefore we need to keep track of the fields
     * and trigger the click after all the listeners are set
     */
    let dataFieldShowHideAll = [];

    /**
     * Event listener on a field to be display if another field has this value
     * Note: accept 1 field with multiple value separated with pipe: data-show-if="[name=category],upgrade_br100|upgrade_step2"
     */
    $("[data-field-show-if]").each(function() {
        let element = $(this);
        let data = element.data("fieldShowIf").split(',');
        let field = data.shift();
        let value = data.pop().split('|');
        // Add the field to the list
        dataFieldShowHideAll.push(field);
        $(`${field}`).on("change", function(e) {
            if (value.includes($(this).val())) element.removeClass("d-none");
            else element.addClass("d-none");
        });
    });

    /**
     * Hide a field if another has the value (for general use)
     */
    $("[data-field-hide-if]").each(function(index, el) {
        let element = $(this);
        let data = element.data("fieldHideIf").split(',');
        let field = data.shift();
        let value = data.pop().split('|');
        // Add the field to the list
        dataFieldShowHideAll.push(field);
        $(`${field}`).on("change", function(e) {
            if (value.includes($(this).val())) element.addClass("d-none")
            else element.removeClass("d-none")
        });
    })

    /**
     * Enable a field if another has the value (for general use)
     */
    $("[data-field-enable-if]").each(function() {
        let element = $(this);
        let data = element.data("fieldEnableIf").split(',');
        let childs = element.find('select, input, textarea');
        let field = data.shift();
        let value = data.pop().split('|');
        // For date picker we must remove a class
        const isFlatpickr = element.data('flatpickr') || childs.data('flatpickr');
        // Add the field to the list
        dataFieldShowHideAll.push(field);
        $(`${field}`).on("change", function(e) {
            let enabled = value.includes($(this).val());
            element.prop('disabled', !enabled);
            childs.prop('disabled', !enabled);
            if (isFlatpickr) {
                element.toggleClass('flatpickr-input', enabled);
                childs.toggleClass('flatpickr-input', enabled);
            }
        });
    });

    /**
     * Disable a field if another has the value (for general use)
     */
    $("[data-field-disable-if]").each(function() {
        let element = $(this);
        let data = element.data("fieldDisableIf").split(',');
        let childs = element.find('select, input, textarea');
        let field = data.shift();
        let value = data.pop().split('|');
        // For date picker we must remove a class
        const isFlatpickr = element.data('flatpickr') || childs.data('flatpickr');
        // Add the field to the list
        dataFieldShowHideAll.push(field);
        $(`${field}`).on("change", function(e) {
            let disabled = value.includes($(this).val());
            element.prop('disabled', disabled);
            childs.prop('disabled', disabled);
            if (isFlatpickr) {
                element.toggleClass('flatpickr-input', !disabled);
                childs.toggleClass('flatpickr-input', !disabled);
            }
        });
    });

    /**
     * Enable a field if another is checked (for general use)
     */
    $("[data-field-enable-if-checked]").each(function() {
        let element = $(this);
        let field = element.data("fieldEnableIfChecked");
        let childs = element.find('select, input, textarea');
        // For date picker we must remove a class
        const isFlatpickr = element.data('flatpickr') || childs.data('flatpickr');
        // Add the field to the list
        dataFieldShowHideAll.push(field);
        $(`${field}`).on("change", function(e) {
            let checked = $(this).prop("checked");
            element.prop('disabled', !checked);
            childs.prop('disabled', !checked);
            if (isFlatpickr) {
                element.toggleClass('flatpickr-input', checked);
                childs.toggleClass('flatpickr-input', checked);
            }
        });
    });

    /**
     * Show a field if another is checked (for general use)
     */
    $("[data-field-show-if-checked]").each(function() {
        let element = $(this);
        let field = element.data("fieldShowIfChecked");
        // Add the field to the list
        dataFieldShowHideAll.push(field);
        $(`${field}`).on("change", function(e) {
            let checked = $(this).prop("checked");
            if (checked) element.removeClass("d-none");
            else element.addClass("d-none");
        });
    });

    /**
     * Hide a field if another is checked (for general use)
     */
    $("[data-field-hide-if-checked]").each(function() {
        let element = $(this);
        let field = element.data("fieldHideIfChecked");
        // Add the field to the list
        dataFieldShowHideAll.push(field);
        $(`${field}`).on("change", function(e) {            
            let checked = $(this).prop("checked");
            if (checked) element.addClass("d-none");
            else element.removeClass("d-none");
        });
    });

    /**
     * Trigger initial single click for all unique (Set) data-field-show/hide-if, data-field-enable/disable-if
     */
    [...new Set(dataFieldShowHideAll)].forEach(items => {
        const fields = $(items);
        if (fields.length > 0) fields.first().trigger('change');
    });

    /**
     * Event listener on a collapse to show/hide other (ex; after submitting a form)
     */
    $('[data-auto-collapse="1"]').trigger('click');

    /**
     * Open modal on error, useful when user submitted from a modal and got error bags not empty
     */
    $('[data-open-modal-on-error=1]').modal('show');

    /**
     * Display name of file(s) when custom input is used
     */
    $('.form-file-label').each(function() {
        let container = $(this)
        let file = $(`[name=${container.attr("for")}], [id=${container.attr("for")}]`)
        let text = container.find(".form-file-text")            
        file.on("change", function(e) {
            if ($(this)[0].files.length == 0) text.text('')
            else if ($(this)[0].files.length == 1) text.text($(this).val())
            else text.text(Array.from($(this)[0].files).map(f => f.name).join())
        })
    })

    /**
     * Prevent double click on form - works only on normal form not uploadcloud
     */
    $('.prevent-double-click').on('submit', function() {
        let id = $(this).attr('id')
        $(`[form=${id}]`).addClass('btn-loading')
    })

    /**
     * Change visibility of buttons for modals
     */
    $('#modal-cancel-confirm, #modal-shutdown-confirm, #modal-restart-confirm, #modal-rerun-confirm, #modal-runnow-confirm, #modal-delete-confirm, #modal-action-confirm, #modal-restore-confirm').on('click', function() {
        $(this).addClass("btn-loading")
    })

    /**
     * Restore button status when showing modals
     */
    $('#modal-confirm, #modal-shutdown, #modal-rerun, #modal-runnow, #modal-cancel, #modal-delete, #modal-action, #modal-restore').on('hidden.bs.modal', function() {
        $("#modal-cancel-confirm, #modal-shutdown-confirm, #modal-restart-confirm, #modal-rerun-confirm, #modal-runnow-confirm, #modal-delete-confirm, #modal-action-confirm, #modal-restore-confirm").removeClass("btn-loading")
    })

    /**
     * Add event listener on file upload to enable/disable the button and avoid misclick from users
     */
    $('#workflow_upload').find("input[type=file]").on('change', function(e) {
        let button = $('#workflow_upload').find("button[type=submit]")
        if ($(this).get(0).files.length === 0) button.prop('disabled', true)
        else button.prop('disabled', false)
    }).trigger("change")

    /**
     * Add event listener on file upload for manual step in workflows
     */
    $('#workflow_upload').on('submit', function(e) {
        e.preventDefault()
        let form = $(this)
        let fileInput = form.find("input[type=file]")[0]
        let isMultiple = $(fileInput).is('[multiple]')
        let list = []
        let redirect = form.data('uploadRedirect');
          
        for (var i = 0; i < fileInput.files.length; i++) {
			list.push(fileInput.files[i])
		}        
        // Send to upload or just submit the form via ajax        
        if (list.length > 0) {
            uploadcloud.fromList(form, list, (list) => {
                // We must receive an array of uuids and names
                if (Array.isArray(list) && list.length > 0) {
                    let data = {
                        file: list[0].name,
                        file_uuid: list[0].uuid
                    }
                    // If the upload input is multiple (for validations)
                    if (isMultiple) data = { list: list };
                    // Send the request back to action
                    $.ajax({
                        url: form.attr('action'),
                        method: form.find("input[name='_method']").val() || form.attr('method'),
                        data: data
                    })
                    .done((res) => {
                        window.location.replace(redirect);
                    })
                    .fail((jqXHR, textStatus) => {
                        console.error(jqXHR)
                    })
                } else {
                    console.error(list)
                }          
            })
        } else {
            if (confirm("Do you want to skip the manual changes?")) {
                // There is no file, user wants to skip
                $.ajax({
                    url: form.attr('action'),
                    method: form.find("input[name='_method']").val() || form.attr('method'),
                })
                .done((res) => {
                    window.location.replace(`${form.data('uploadRedirect')}`);
                })
                .fail((jqXHR, textStatus) => {
                    console.error(jqXHR)
                })
            }            
        }
    })

    /**
     * Event listener on button to show/hide password field
     */
    $('.show-password').on("click", function (e) {
        let input = $(this).closest("div").find("input")
        if (input.attr("type") == 'password') input.attr("type", "text")
        else input.attr("type", "password")
    })

    /**
     * Initiate toast
     */
    $('.toast').toast({delay: 5000})
    $('.toast').toast('show')

    /**
     * Disable autofill on all input - must stay at the very end of js
     */
    $('input').attr("autocomplete", "off")

    /**
     * Initiate tooltips
     */
    $('[data-toggle="tooltip"]').tooltip()
    $(document).ajaxComplete(function() {
        $('[data-toggle="tooltip"]').tooltip()
    });

    /**
     * Handl clik on a row
     */
    $('tr[data-href]').on('click', function() {
        window.location = $(this).data('href');
    });

    /**
     * Display session ending, listen to extend session click
     */
    if ($("#modal-session").length > 0) {
        let modalSession = $("#modal-session");
        let showSessionWarning;

        const setSessionWarning = () => {
            setTimeout(() => {
                modalSession.modal('show');
                showSessionWarning = setTimeout(() => modalSession.find("a.btn-white")[0].click(), 2 * 60 * 1000);
            }, modalSession.data("lifetime") * 60 * 1000);
        };

        modalSession.find("a.btn-primary").on("click", function(e) {
            e.preventDefault();
            $.get(window.location.href);
            clearTimeout(showSessionWarning);
            setSessionWarning();
            modalSession.modal('hide');
        });
        setSessionWarning();
    }
})